// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"512":"143d093a","749":"9a2a3fed"}[chunkId] + ".chunk.css";
};